import { Grid, makeStyles, Paper, Table, TableBody, TableCell as TableCellBase, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { Events } from '@type-r/models';
import { useCollection, useIO, useLinked } from '@type-r/react';
import { Flex, PageLayout, PrimaryButton, Toolbar, Loading } from 'lqx-react';
import * as React from 'react';
import { CompanyModel } from 'api';
import { SearchToolbar } from './toolbar';
import { filterLengthThreshold } from 'api/common';

export const CompaniesLandingPage = () => {
    const companies = useCollection.of(CompanyModel);
    const $filter = useLinked('');
    const isReady = useIO(async () => await companies.fetch(
        { params: {searchString: $filter.value, useFingerprintWildcard: true, take: 100, partial: true } }
    ).catch(e => console.error(e)),
        [filterLengthThreshold($filter.value)]);

    return (
            <PageLayout
                header={
                    <Toolbar>
                        <Flex grow />
                        <PrimaryButton
                            variant="contained"
                            onClick={() => Events.trigger( 'navigate', '/companies/new')}
                        >
                            New Company
                        </PrimaryButton>
                    </Toolbar>
                }

                subheader={
                    <SearchToolbar
                        $filter={ $filter }
                    />
                }
            >
            {
            isReady ?
                <CompaniesList
                    companies={companies}
                />
                : <Loading />
            }
            </PageLayout>

    )
}

export const CompaniesList = ({ companies }) => {
  const classes = useStyles();

  return (
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableHeader align="left">Company</TableHeader>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {companies.map(row => {
                        return (
                            <TableRow key={row.cid} onClick={() => Events.trigger( 'navigate', `/companies/${row.id}`)}>
                                <TableCell component="th" scope="row" align="left">
                                    <CompanyCellEntry
                                        companyName={row.name}
                                        city={row.city}
                                    />
                                </TableCell>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </TableContainer>
  )
}

const CompanyCellEntry = ({ companyName, city }) => {
  const classes = useStyles();
  return (
      <Grid container>
          <Grid item xs={12} className={classes.cellHeading}>
              {companyName}
          </Grid>
          <Grid item xs={12} className={classes.cellSubheading}>
              {'City: '+ city}
          </Grid>
      </Grid>
  )
}

const TableCell = (props) => {
  const classes = useStyles();
  return (
      <TableCellBase
          className={classes.tableCell}
          {...props}
      />
  )
}

const TableHeader = (props) => {
  const classes = useStyles();
  return (
      <TableCellBase
          className={classes.tableHeader}
          {...props}
      />
  )
}

const useStyles = makeStyles({
  cellHeading: {
      fontWeight: 500,
      marginBottom: '5px'
  },

  cellSubheading: {
      color: '#899094',
      fontSize: '13px',
      lineHeight: '15px'
  },

  tableHeader: {
      color: '#899095',
      fontFamily: 'Montserrat',
      fontSize: '12px',
      fontWeight: 500,
      lineHeight: '14px',
      textTransform: 'uppercase',
      '&.MuiTableCell-root': {
          padding: '16px'
      }
  },

  tableCell: {
      color: '#000',
      fontFamily: 'Montserrat',
      fontSize: '14px',
      lineHeight: '17px',
      '&.MuiTableCell-root': {
          padding: '16px'
      }
  },
})
